export default {
  pricingData: [],
  pricingTerms: [],
  sopPricing: false
}
